import React from "react";
import BannerImage from "../Component/IMG-20251113-WA0052.jpg";
const CoursesPageFixed = () => {
  return (
    <div>
      <style>{`
/* ---------------------------------------------
   MAIN PAGE
--------------------------------------------- */
.courses-page-main {
  background-color: #f9f9f9;
  margin-top: 100px;
  font-family: "Poppins", sans-serif;
}

/* ---------------------------------------------
   BANNER SECTION
--------------------------------------------- */
.courses-banner-new {
  width: 100%;
  height: 100vh;  /* Full screen height */
  overflow: hidden;
  position: relative;
}


.courses-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  display: block;
}



/* ---------------------------------------------
   COURSES CONTAINER
--------------------------------------------- */

.courses-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 15px;
}

/* ---------------------------------------------
   GRID LAYOUT
--------------------------------------------- */

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 22px;
  padding: 10px;
}

/* ---------------------------------------------
   PREMIUM COURSE CARD
--------------------------------------------- */

.course-card-new {
  background: #ffffff;
  padding: 28px;
  border-radius: 14px;
  border: 1px solid #e8eef5;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  transition: all 0.3s ease;
  position: relative;
}

.course-card-new:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-color: #c8dbff;
}

/* Decorative Line */
.course-card-new::before {
  content: "";
  width: 50px;
  height: 3px;
  background: #0d6efd;
  display: block;
  border-radius: 2px;
  margin-bottom: 14px;
}

.course-title-new {
  font-size: 1.4rem;
  font-weight: 700;
  color: #0d6efd;
  margin-bottom: 10px;
}

.course-desc-new {
  font-size: 1rem;
  color: #444;
  line-height: 1.75;
}

/* ---------------------------------------------
   TABLET RESPONSIVE (Up to 1024px)
--------------------------------------------- */

@media (max-width: 1024px) {
  .courses-banner-new {
    height: 320px;
    margin-bottom: 50px;
  }
}

/* ---------------------------------------------
   MOBILE RESPONSIVE (Up to 768px)
--------------------------------------------- */

@media (max-width: 768px) {
  .courses-page-main {
    margin-top: 80px;
  }

  .courses-banner-new {
    height: 260px;
    margin-bottom: 40px;
  }

  .course-title-new {
    font-size: 1.2rem;
  }

  .courses-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .courses-wrapper {
    padding: 30px 15px;
  }
}

/* ---------------------------------------------
   SMALL MOBILE (Up to 480px)
--------------------------------------------- */

@media (max-width: 480px) {
  .courses-page-main {
    margin-top: 70px;
  }

  .courses-banner-new {
    height: 220px;
    margin-bottom: 30px;
  }

  .course-card-new {
    padding: 22px;
  }

  .courses-wrapper {
    padding: 25px 12px;
  }
}
      `}</style>
      
      <div className="courses-page-main">
        {/* 🔹 Banner Section */}
        <div className="courses-banner-new">
          <img 
            src={BannerImage}
            alt="Courses Banner" 
            className="courses-banner-img" 
          />
        </div>

        {/* 🔹 Course List Section */}
        <div className="courses-wrapper container py-5">
          <h2 style={{fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#0d6efd'}}>
            Skill Development & Certification Programs
          </h2>

          <div className="courses-grid">
            {[
              {
                title: "O-Level",
                description: "The O-Level course is designed to provide a strong foundation in computer applications and programming. Students learn about IT tools, internet usage, data management, and programming languages like Python."
              },
              {
                title: "CCC (Course on Computer Concepts)",
                description: "The CCC course introduces basic computer operation, digital payments, internet usage, and office tools. Perfect for beginners."
              },
              {
                title: "ADCA (Advanced Diploma in Computer Applications)",
                description: "ADCA covers programming, database management, web development, and accounting software for IT career development."
              },
              {
                title: "PGDCA (Post Graduate Diploma in Computer Applications)",
                description: "PGDCA provides software development, system design, and IT management skills ideal for professional roles."
              },
              {
                title: "Tally & Communication",
                description: "This course covers accounting with Tally + communication skills, email writing, GST, and business management."
              },
              {
                title: "Spoken English",
                description: "Improve fluency, pronunciation and confidence in English with practical training."
              }
            ].map((course, index) => (
              <div className="course-card-new" key={index}>
                <h4 className="course-title-new">{course.title}</h4>
                <p className="course-desc-new">{course.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesPageFixed;